import type { RouteObject } from "react-router-dom";
import AppVersionsPage, { appVersionsLoader } from "./List";
import AppVersionFormPage, { editAppVersionLoader, newAppVersionLoader } from "./Form";
import AppError from "../app-error";

export const appVersionsRoutes: RouteObject[] = [
  { path: "app-versions", Component: AppVersionsPage, loader: appVersionsLoader, errorElement: <AppError /> },
  { path: "app-versions/new", Component: AppVersionFormPage, loader: newAppVersionLoader, errorElement: <AppError /> },
  { path: "app-versions/:key", Component: AppVersionFormPage, loader: editAppVersionLoader, errorElement: <AppError /> },
];
